var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { inject, onMounted, defineComponent, computed, pushScopeId, popScopeId, openBlock, createBlock, resolveDynamicComponent, renderSlot, createVNode, toDisplayString, createCommentVNode, withScopeId, resolveComponent, Fragment, createTextVNode, renderList, createStaticVNode, ref, onBeforeUnmount, onErrorCaptured, withDirectives, withKeys, withModifiers, vModelText, watch } from "vue";
const hasSymbol = typeof Symbol === "function" && typeof Symbol.toStringTag === "symbol";
const PolySymbol = (name) => hasSymbol ? Symbol(name) : name;
const seeelayeKey = PolySymbol("seeelaye");
const useSeeelaye = () => {
  const seeelaye = inject(seeelayeKey);
  if (!seeelaye) {
    throw new Error("see\xB7el\xB7aye is not installed.");
  }
  return seeelaye;
};
const _Interaction = class {
  constructor(context, rawInput) {
    this.context = context;
    this.rawInput = rawInput;
    const [bin, ...argv] = rawInput.split(/\s+/);
    this.input = {
      bin,
      argv
    };
    this.isVisible = true;
  }
  processOutput() {
    if (!this.rawInput) {
      this.output = {
        component: "Nop",
        argv: []
      };
      return;
    }
    const binary = _Interaction.allBins[this.input.bin];
    if (binary) {
      this.output = {
        component: binary.name,
        argv: this.input.argv
      };
    } else {
      this.output = {
        component: "Bad",
        argv: [this.input.bin]
      };
    }
  }
  hide() {
    this.isVisible = false;
  }
};
let Interaction = _Interaction;
Interaction.allBins = {};
const flagSymbol = Symbol("arg flag");
class ArgError extends Error {
  constructor(msg, code) {
    super(msg);
    this.name = "ArgError";
    this.code = code;
    Object.setPrototypeOf(this, ArgError.prototype);
  }
}
function arg(opts, { argv = process.argv.slice(2), permissive = false, stopAtPositional = false } = {}) {
  if (!opts) {
    throw new ArgError("argument specification object is required", "ARG_CONFIG_NO_SPEC");
  }
  const result = { _: [] };
  const aliases = {};
  const handlers = {};
  for (const key of Object.keys(opts)) {
    if (!key) {
      throw new ArgError("argument key cannot be an empty string", "ARG_CONFIG_EMPTY_KEY");
    }
    if (key[0] !== "-") {
      throw new ArgError(`argument key must start with '-' but found: '${key}'`, "ARG_CONFIG_NONOPT_KEY");
    }
    if (key.length === 1) {
      throw new ArgError(`argument key must have a name; singular '-' keys are not allowed: ${key}`, "ARG_CONFIG_NONAME_KEY");
    }
    if (typeof opts[key] === "string") {
      aliases[key] = opts[key];
      continue;
    }
    let type = opts[key];
    let isFlag = false;
    if (Array.isArray(type) && type.length === 1 && typeof type[0] === "function") {
      const [fn] = type;
      type = (value, name, prev = []) => {
        prev.push(fn(value, name, prev[prev.length - 1]));
        return prev;
      };
      isFlag = fn === Boolean || fn[flagSymbol] === true;
    } else if (typeof type === "function") {
      isFlag = type === Boolean || type[flagSymbol] === true;
    } else {
      throw new ArgError(`type missing or not a function or valid array type: ${key}`, "ARG_CONFIG_VAD_TYPE");
    }
    if (key[1] !== "-" && key.length > 2) {
      throw new ArgError(`short argument keys (with a single hyphen) must have only one character: ${key}`, "ARG_CONFIG_SHORTOPT_TOOLONG");
    }
    handlers[key] = [type, isFlag];
  }
  for (let i = 0, len = argv.length; i < len; i++) {
    const wholeArg = argv[i];
    if (stopAtPositional && result._.length > 0) {
      result._ = result._.concat(argv.slice(i));
      break;
    }
    if (wholeArg === "--") {
      result._ = result._.concat(argv.slice(i + 1));
      break;
    }
    if (wholeArg.length > 1 && wholeArg[0] === "-") {
      const separatedArguments = wholeArg[1] === "-" || wholeArg.length === 2 ? [wholeArg] : wholeArg.slice(1).split("").map((a) => `-${a}`);
      for (let j = 0; j < separatedArguments.length; j++) {
        const arg2 = separatedArguments[j];
        const [originalArgName, argStr] = arg2[1] === "-" ? arg2.split(/=(.*)/, 2) : [arg2, void 0];
        let argName = originalArgName;
        while (argName in aliases) {
          argName = aliases[argName];
        }
        if (!(argName in handlers)) {
          if (permissive) {
            result._.push(arg2);
            continue;
          } else {
            throw new ArgError(`unknown or unexpected option: ${originalArgName}`, "ARG_UNKNOWN_OPTION");
          }
        }
        const [type, isFlag] = handlers[argName];
        if (!isFlag && j + 1 < separatedArguments.length) {
          throw new ArgError(`option requires argument (but was followed by another short argument): ${originalArgName}`, "ARG_MISSING_REQUIRED_SHORTARG");
        }
        if (isFlag) {
          result[argName] = type(true, argName, result[argName]);
        } else if (argStr === void 0) {
          if (argv.length < i + 2 || argv[i + 1].length > 1 && argv[i + 1][0] === "-" && !(argv[i + 1].match(/^-?\d*(\.(?=\d))?\d*$/) && (type === Number || typeof BigInt !== "undefined" && type === BigInt))) {
            const extended = originalArgName === argName ? "" : ` (alias for ${argName})`;
            throw new ArgError(`option requires argument: ${originalArgName}${extended}`, "ARG_MISSING_REQUIRED_LONGARG");
          }
          result[argName] = type(argv[i + 1], argName, result[argName]);
          ++i;
        } else {
          result[argName] = type(argStr, argName, result[argName]);
        }
      }
    } else {
      result._.push(wholeArg);
    }
  }
  return result;
}
arg.flag = (fn) => {
  fn[flagSymbol] = true;
  return fn;
};
arg.COUNT = arg.flag((v, name, existingCount) => (existingCount || 0) + 1);
arg.ArgError = ArgError;
var arg_1 = arg;
class Binary {
  constructor(name, command, description, args, kwargs) {
    this.name = name;
    this.command = command;
    this.description = description;
    this.args = args;
    this.kwargs = kwargs;
  }
  get allArgs() {
    return [
      ...this.kwargs.map((kwarg) => kwarg.repr),
      ...this.args.map((arg2) => arg2.repr)
    ];
  }
  toJSON() {
    return {
      name: this.name,
      command: this.command,
      allArgs: this.allArgs
    };
  }
  processArgs(argv) {
    const spec = {};
    this.kwargs.forEach((arg2) => {
      var _a;
      spec[`--${arg2.name}`] = arg2.handler;
      (_a = arg2.aliases) == null ? void 0 : _a.forEach((alias) => {
        spec[`-${alias}`] = `--${arg2.name}`;
      });
    });
    const processed = arg_1(spec, {
      argv,
      permissive: true
    });
    this.kwargs.forEach((arg2) => {
      arg2.setHandlerValue(processed[`--${arg2.name}`]);
    });
    this.args.forEach((arg2) => {
      const value = processed._.shift();
      if (value) {
        arg2.setHandlerValue(value);
      } else if (arg2.isRequired) {
        throw new Error(`Required argument <strong>${arg2.name}</strong> was not provided to <strong>${this.command}</strong>.`);
      }
    });
  }
}
var ArgType;
(function(ArgType2) {
  ArgType2["POSITIONAL"] = "pos";
  ArgType2["KEYWORD"] = "kw";
})(ArgType || (ArgType = {}));
class AArg {
  constructor(type, name, description, handler, defaultValue, aliases = []) {
    this.type = type;
    this.name = name;
    this.description = description;
    this.handler = handler;
    if (defaultValue !== void 0) {
      this.defaultValue = defaultValue;
      this.setHandlerValue(defaultValue);
    }
    this.aliases = aliases;
  }
  get isRequired() {
    return this.defaultValue === void 0;
  }
  get repr() {
    let repr = this.name;
    if (this.type === ArgType.KEYWORD) {
      repr = `--${repr}`;
    }
    if (this.aliases) {
      this.aliases.forEach((alias) => {
        repr = `${repr}/-${alias}`;
      });
    }
    if (this.defaultValue && typeof this.defaultValue !== "boolean") {
      repr = `${repr}='${this.defaultValue}'`;
    }
    if (!this.isRequired) {
      repr = `[${repr}]`;
    }
    return repr;
  }
  setHandlerValue(value) {
    this.handlerValue = value;
  }
}
class Arg extends AArg {
  get value() {
    return this.handlerValue;
  }
}
class NodeArg extends AArg {
  constructor(type, name, description, fsNodeType, defaultValue, aliases) {
    super(type, name, description, String, defaultValue, aliases);
    this.fsNodeType = fsNodeType;
  }
  get value() {
    const seeelaye = useSeeelaye();
    return seeelaye.compute("nodeLocatedAt", {
      path: this.handlerValue
    });
  }
  get isNodeFound() {
    return this.value !== null;
  }
  get isNodeValidType() {
    if (!this.value)
      return false;
    if (!this.fsNodeType)
      return true;
    return this.value.isType(this.fsNodeType);
  }
}
var FsNodeType;
(function(FsNodeType2) {
  FsNodeType2["FILE"] = "file";
  FsNodeType2["FOLDER"] = "folder";
})(FsNodeType || (FsNodeType = {}));
const nameExtSplit = (fullName) => {
  if (!fullName.includes(".")) {
    return [fullName, null];
  }
  const lastDot = fullName.lastIndexOf(".");
  const name = fullName.substring(0, lastDot);
  const extension = fullName.substring(lastDot + 1);
  return [name, extension];
};
const pathSplit = (path) => {
  const pathParts = path.replace(/\/+/g, "/").split(/(\/)/);
  let parts = [];
  for (let i = 0; i < pathParts.length; i += 1) {
    if (pathParts[i] === "/") {
      parts[parts.length - 1] = `${parts[parts.length - 1]}/`;
    } else {
      parts.push(pathParts[i]);
    }
  }
  if (parts[parts.length - 1] === "") {
    parts = parts.slice(0, parts.length - 1);
  }
  return parts;
};
const extLang = Object.freeze({
  java: "java",
  js: "javascript",
  md: "markdown",
  py: "python",
  rb: "ruby",
  rst: "markdown",
  tex: "latex",
  ts: "typescript",
  vue: ["xml", "javascript", "typescript"],
  yml: "yaml"
});
const specialNames = Object.freeze({
  HOME_DIR: ["~", "~/"],
  CURRENT_DIR: [".", "./"],
  PARENT_DIR: ["..", "../"]
});
class FsNode {
  constructor(type, name, aliases = []) {
    this.type = type;
    this.name = name;
    this.aliases = aliases;
    this.parent = this;
    this.children = [];
  }
  get isFolder() {
    return this.isType(FsNodeType.FOLDER);
  }
  get isFile() {
    return this.isType(FsNodeType.FILE);
  }
  get isRoot() {
    return this.parent === this;
  }
  get allNames() {
    const allNames = [this.name, ...this.aliases];
    if (this.isFile) {
      allNames.forEach((name) => {
        const [nameMinusExt] = nameExtSplit(name);
        allNames.push(nameMinusExt);
      });
    }
    if (this.isFolder) {
      allNames.forEach((name) => {
        allNames.push(`${name}/`);
      });
    }
    if (this.isRoot) {
      allNames.push("/");
    }
    return Array.from(new Set(allNames));
  }
  get autocompleteName() {
    if (this.isFolder) {
      return `${this.name}/`;
    }
    return `${this.name} `;
  }
  get language() {
    if (this.isFolder)
      return null;
    const [, ext] = nameExtSplit(this.name);
    if (!ext)
      return null;
    const language = extLang[ext];
    if (!language)
      return null;
    if (Array.isArray(language)) {
      return language;
    }
    return [language];
  }
  get absolutePath() {
    if (this.isRoot) {
      return this.name;
    }
    return `${this.parent.absolutePath}/${this.name}`;
  }
  toJSON() {
    return {
      name: this.name,
      aliases: this.aliases,
      isFile: this.isFile,
      isFolder: this.isFolder,
      absolutePath: this.absolutePath
    };
  }
  isType(type) {
    return this.type === type;
  }
  hasName(name, isPartial = false) {
    const allNames = this.allNames.map((nodeName) => nodeName.toLowerCase());
    if (isPartial) {
      return allNames.some((nodeName) => nodeName.includes(name.toLowerCase()));
    }
    return allNames.includes(name.toLowerCase());
  }
  traverse(func) {
    let shouldContinue = func(this);
    if (!shouldContinue) {
      return shouldContinue;
    }
    Array.from(this.children.values()).every((child) => {
      shouldContinue = child.traverse(func);
      return shouldContinue;
    });
    return shouldContinue;
  }
  descendantNamed(name) {
    let result = null;
    this.traverse((node) => {
      if (node.hasName(name)) {
        result = node;
        return false;
      }
      return true;
    });
    return result;
  }
  static parse(pojo) {
    const type = pojo.children ? FsNodeType.FOLDER : FsNodeType.FILE;
    const node = new FsNode(type, pojo.name, pojo.aliases);
    if (pojo.children) {
      pojo.children.forEach((childPojo) => {
        const childNode = FsNode.parse(childPojo);
        node.children.push(childNode);
        childNode.parent = node;
      });
    }
    return node;
  }
}
const binProps = {
  argv: {
    type: Array,
    default: () => []
  }
};
const binComposition = (markReadyOnMount = true) => {
  const seeelaye = useSeeelaye();
  const setTerminalReady = (isReady = true) => {
    seeelaye.commit("setIsReady", { isReady });
  };
  if (markReadyOnMount) {
    onMounted(() => {
      setTerminalReady(true);
    });
  }
  return {
    setTerminalReady
  };
};
var _sfc_main$k = defineComponent({
  name: "Navigable",
  props: {
    node: {
      type: Object,
      required: true
    },
    showAliases: {
      type: Boolean,
      default: false
    },
    isClickable: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    const seeelaye = useSeeelaye();
    const command = computed(() => {
      const bin = props.node.isFolder ? "cd" : "cat";
      const argv = [props.node.absolutePath];
      return [bin, ...argv].join(" ");
    });
    const navigate = () => {
      if (!props.isClickable)
        return;
      seeelaye.dispatch("executeCmd", {
        rawInput: command.value
      });
    };
    return {
      handleClick: navigate
    };
  }
});
var Navigable_vue_vue_type_style_index_0_scoped_true_lang = "\nbutton.navigable[data-v-5f8118e1] { /* Reset UA button */\n    appearance: none;\n\n    font-family: inherit;\n    font-size: inherit;\n    background: none;\n\n    padding: 0;\n    border: none;\n}\nbutton.navigable[data-v-5f8118e1] {\n    cursor: pointer;\n}\n.is-folder[data-v-5f8118e1] {\n    color: var(--folder-color, var(--color-normal-cyan));\n    font-weight: bold;\n}\n.is-file[data-v-5f8118e1] {\n    color: var(--file-color, var(--color-normal-magenta));\n    font-weight: normal;\n}\n.navigable .aliases[data-v-5f8118e1-s] {\n    color: var(--alias-color, var(--color-secondary-fg));\n    font-weight: normal;\n}\n";
const _withId$c = /* @__PURE__ */ withScopeId("data-v-5f8118e1");
pushScopeId("data-v-5f8118e1");
const _hoisted_1$j = {
  key: 0,
  class: "aliases"
};
popScopeId();
const _sfc_render$k = /* @__PURE__ */ _withId$c((_ctx, _cache, $props, $setup, $data, $options) => {
  return openBlock(), createBlock(resolveDynamicComponent(_ctx.isClickable ? "button" : "span"), {
    class: ["navigable", [_ctx.node.isFolder ? "is-folder" : "is-file"]],
    onClick: _ctx.handleClick
  }, {
    default: _withId$c(() => [
      renderSlot(_ctx.$slots, "default", {}, () => [
        createVNode("span", null, toDisplayString(_ctx.node.name), 1),
        _ctx.showAliases && _ctx.node.aliases.length ? (openBlock(), createBlock("span", _hoisted_1$j, "\xA0(~ " + toDisplayString(_ctx.node.aliases.join(", ")) + ")", 1)) : createCommentVNode("", true)
      ])
    ]),
    _: 3
  }, 8, ["class", "onClick"]);
});
_sfc_main$k.render = _sfc_render$k;
_sfc_main$k.__scopeId = "data-v-5f8118e1";
const dirpathFn$2 = () => new NodeArg(ArgType.POSITIONAL, "dirpath", "the path or name of the directory to switch to", FsNodeType.FOLDER, specialNames.HOME_DIR[0]);
const verboseFn$1 = () => new Arg(ArgType.KEYWORD, "verbose", "whether to display more information on-screen", Boolean, false, ["v"]);
const binaryFn$a = () => {
  const dirpath = dirpathFn$2();
  const verbose = verboseFn$1();
  return new Binary("ChangeDir", "cd", "Switch to the given directory as the working directory.", [dirpath], [verbose]);
};
var _sfc_main$j = defineComponent({
  name: "ChangeDir",
  props: binProps,
  components: {
    Navigable: _sfc_main$k
  },
  setup(props) {
    const binary = binaryFn$a();
    const dirpath = binary.args[0];
    const verbose = binary.kwargs[0];
    binComposition();
    binary.processArgs(props.argv);
    const verboseValue = verbose.value;
    const dirpathValue = dirpath.handlerValue;
    const node = dirpath.value;
    const isNodeOk = dirpath.isNodeFound && dirpath.isNodeValidType;
    const seeelaye = useSeeelaye();
    if (isNodeOk) {
      seeelaye.commit("setCurrentNode", {
        currentNode: node
      });
    }
    return {
      dirpath: dirpathValue,
      verbose: verboseValue,
      node,
      isNodeOk
    };
  }
});
const _hoisted_1$i = { class: "cd" };
const _hoisted_2$9 = { class: "error" };
const _hoisted_3$5 = /* @__PURE__ */ createTextVNode(" is not a valid directory. ");
const _hoisted_4$5 = /* @__PURE__ */ createTextVNode(" Changed to ");
const _hoisted_5$3 = /* @__PURE__ */ createTextVNode(". ");
function _sfc_render$j(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Navigable = resolveComponent("Navigable");
  return openBlock(), createBlock("div", _hoisted_1$i, [
    !_ctx.node || !_ctx.isNodeOk ? (openBlock(), createBlock(Fragment, { key: 0 }, [
      createVNode("strong", _hoisted_2$9, toDisplayString(_ctx.dirpath), 1),
      _hoisted_3$5
    ], 64)) : _ctx.verbose ? (openBlock(), createBlock(Fragment, { key: 1 }, [
      _hoisted_4$5,
      createVNode(_component_Navigable, {
        node: _ctx.node,
        "is-clickable": false
      }, null, 8, ["node"]),
      _hoisted_5$3
    ], 64)) : createCommentVNode("", true)
  ]);
}
_sfc_main$j.render = _sfc_render$j;
const binaryFn$9 = () => new Binary("Clear", "clear", "Clear the screen by hiding all previous interactions.", [], []);
var _sfc_main$i = defineComponent({
  name: "Clear",
  setup() {
    binComposition();
    const seeelaye = useSeeelaye();
    seeelaye.commit("hideInteractions");
  }
});
const _hoisted_1$h = { class: "clear" };
function _sfc_render$i(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock("div", _hoisted_1$h);
}
_sfc_main$i.render = _sfc_render$i;
const binaryFn$8 = () => new Binary("Hello", "hello", "Display ASCII art for see\xB7el\xB7aye along with relevant links.", [], []);
var _sfc_main$h = defineComponent({
  name: "Hello",
  command: "hello",
  description: "Display ASCII art for see\xB7el\xB7aye along with relevant links.",
  setup() {
    binComposition();
    const links = [
      {
        text: "\u{1F4BB} GitHub",
        href: "https://github.com/dhruvkb/seeelaye"
      },
      {
        text: "\u{1F4D5} Docs",
        href: "https://seeelaye.vercel.app"
      },
      {
        text: "\u{1F4E6} npm",
        href: "https://www.npmjs.com/package/seeelaye"
      }
    ];
    return {
      links
    };
  }
});
var Hello_vue_vue_type_style_index_0_scoped_true_lang = "\n.red[data-v-69a678ea] {\n    color: #dc322f;\n    font-weight: 600;\n}\n.grey[data-v-69a678ea] {\n    color: #7f7f7f;\n    font-weight: 400;\n}\npre[data-v-69a678ea] {\n    margin: 0;\n}\nul[data-v-69a678ea] {\n    display: inline-flex;\n    gap: 1ch;\n}\nli[data-v-69a678ea]:not(:first-of-type)::before {\n    content: '/ ';\n    color: var(--color-secondary-fg);\n}\n";
const _withId$b = /* @__PURE__ */ withScopeId("data-v-69a678ea");
pushScopeId("data-v-69a678ea");
const _hoisted_1$g = { class: "hello" };
const _hoisted_2$8 = /* @__PURE__ */ createStaticVNode('<pre class="ascii red" data-v-69a678ea><span class="grey" data-v-69a678ea>    __ </span>             <span class="grey" data-v-69a678ea>   </span>       _  <span class="grey" data-v-69a678ea>   </span>                      <span class="grey" data-v-69a678ea>__ </span>\n<span class="grey" data-v-69a678ea>   / /</span>__  ___  ___  <span class="grey" data-v-69a678ea>   </span>   ___| | <span class="grey" data-v-69a678ea>   </span>   __ _ _   _  ___   <span class="grey" data-v-69a678ea>/ /</span>\n<span class="grey" data-v-69a678ea>  / /</span> __|/ _ \\/ _ \\ <span class="grey" data-v-69a678ea> _ </span>  / _ \\ | <span class="grey" data-v-69a678ea> _ </span>  / _` | | | |/ _ \\ <span class="grey" data-v-69a678ea>/ /</span>\n<span class="grey" data-v-69a678ea> / /</span>\\__ \\  __/  __/ <span class="grey" data-v-69a678ea>(_)</span> |  __/ | <span class="grey" data-v-69a678ea>(_)</span> | (_| | |_| |  __/<span class="grey" data-v-69a678ea>/ /</span>\n<span class="grey" data-v-69a678ea>/_/</span> |___/\\___|\\___| <span class="grey" data-v-69a678ea>   </span>  \\___|_| <span class="grey" data-v-69a678ea>   </span>  \\__,_|\\__, |\\___<span class="grey" data-v-69a678ea>/_/</span>\n<span class="grey" data-v-69a678ea>  </span>                  <span class="grey" data-v-69a678ea>   </span>          <span class="grey" data-v-69a678ea>   </span>        |___/</pre>', 1);
popScopeId();
const _sfc_render$h = /* @__PURE__ */ _withId$b((_ctx, _cache, $props, $setup, $data, $options) => {
  return openBlock(), createBlock("div", _hoisted_1$g, [
    _hoisted_2$8,
    createVNode("ul", null, [
      (openBlock(true), createBlock(Fragment, null, renderList(_ctx.links, (link, index) => {
        return openBlock(), createBlock("li", { key: index }, [
          createVNode("a", {
            href: link.href,
            target: "_blank"
          }, toDisplayString(link.text), 9, ["href"])
        ]);
      }), 128))
    ])
  ]);
});
_sfc_main$h.render = _sfc_render$h;
_sfc_main$h.__scopeId = "data-v-69a678ea";
var _sfc_main$g = defineComponent({
  name: "Executable",
  props: {
    bin: {
      type: Object,
      required: true
    },
    showArgs: {
      type: Boolean,
      default: false
    },
    isClickable: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    const seeelaye = useSeeelaye();
    const execute = () => {
      if (!props.isClickable)
        return;
      seeelaye.dispatch("executeCmd", {
        rawInput: props.bin.command
      });
    };
    return {
      handleClick: execute
    };
  }
});
var Executable_vue_vue_type_style_index_0_scoped_true_lang = "\nbutton.executable[data-v-0e3dc148] { /* Reset UA button */\n    appearance: none;\n\n    font-family: inherit;\n    font-size: inherit;\n    background: none;\n\n    padding: 0;\n    border: none;\n}\nbutton.executable[data-v-0e3dc148] {\n    cursor: pointer;\n}\n.executable[data-v-0e3dc148] {\n    color: var(--binary-color, var(--color-normal-green));\n    font-weight: bold;\n}\n.executable .args[data-v-0e3dc148-s] {\n    color: var(--argument-color, var(--color-normal-blue));\n    font-weight: normal;\n}\n";
const _withId$a = /* @__PURE__ */ withScopeId("data-v-0e3dc148");
pushScopeId("data-v-0e3dc148");
const _hoisted_1$f = {
  key: 0,
  class: "args"
};
popScopeId();
const _sfc_render$g = /* @__PURE__ */ _withId$a((_ctx, _cache, $props, $setup, $data, $options) => {
  return openBlock(), createBlock(resolveDynamicComponent(_ctx.isClickable ? "button" : "span"), {
    class: "executable",
    onClick: _ctx.handleClick
  }, {
    default: _withId$a(() => [
      renderSlot(_ctx.$slots, "default", {}, () => [
        createVNode("span", null, toDisplayString(_ctx.bin.command), 1),
        _ctx.showArgs && _ctx.bin.allArgs.length ? (openBlock(), createBlock("span", _hoisted_1$f, "\xA0" + toDisplayString(_ctx.bin.allArgs.join(" ")), 1)) : createCommentVNode("", true)
      ])
    ]),
    _: 3
  }, 8, ["onClick"]);
});
_sfc_main$g.render = _sfc_render$g;
_sfc_main$g.__scopeId = "data-v-0e3dc148";
const binaryFn$7 = () => new Binary("Help", "help", "Show help about using the terminal.", [], []);
var _sfc_main$f = defineComponent({
  name: "Help",
  components: {
    Executable: _sfc_main$g
  },
  setup() {
    binComposition();
    const seeelaye = useSeeelaye();
    const callableBins = Object.values(seeelaye.allBins);
    return {
      callableBins
    };
  }
});
var Help_vue_vue_type_style_index_0_scoped_true_lang = "\nul[data-v-0e6bd17b] {\n    column-count: 2;\n}\n";
const _withId$9 = /* @__PURE__ */ withScopeId("data-v-0e6bd17b");
pushScopeId("data-v-0e6bd17b");
const _hoisted_1$e = { class: "help" };
const _hoisted_2$7 = /* @__PURE__ */ createTextVNode(" These commands are supported. Hover over them for more info. ");
popScopeId();
const _sfc_render$f = /* @__PURE__ */ _withId$9((_ctx, _cache, $props, $setup, $data, $options) => {
  const _component_Executable = resolveComponent("Executable");
  return openBlock(), createBlock("div", _hoisted_1$e, [
    _hoisted_2$7,
    createVNode("ul", null, [
      (openBlock(true), createBlock(Fragment, null, renderList(_ctx.callableBins, (bin, index) => {
        return openBlock(), createBlock("li", { key: index }, [
          createVNode(_component_Executable, {
            bin,
            "show-args": ""
          }, null, 8, ["bin"])
        ]);
      }), 128))
    ])
  ]);
});
_sfc_main$f.render = _sfc_render$f;
_sfc_main$f.__scopeId = "data-v-0e6bd17b";
const binaryFn$6 = () => new Binary("Hostname", "hostname", "Display the name of the host machine.", [], []);
var _sfc_main$e = defineComponent({
  name: "Hostname",
  setup() {
    binComposition();
    const seeelaye = useSeeelaye();
    const { hostname } = seeelaye.state;
    return {
      hostname
    };
  }
});
const _hoisted_1$d = { class: "hostname" };
function _sfc_render$e(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock("div", _hoisted_1$d, toDisplayString(_ctx.hostname), 1);
}
_sfc_main$e.render = _sfc_render$e;
const dirpathFn$1 = () => new NodeArg(ArgType.POSITIONAL, "dirpath", "the path or name of the directory whose contents to list", FsNodeType.FOLDER, specialNames.CURRENT_DIR[0]);
const allFn = () => new Arg(ArgType.KEYWORD, "all", "whether to display hidden files and directories", Boolean, false, ["a"]);
const binaryFn$5 = () => {
  const dirpath = dirpathFn$1();
  const all = allFn();
  return new Binary("List", "ls", "List the contents of the given directory.", [dirpath], [all]);
};
var _sfc_main$d = defineComponent({
  name: "List",
  components: {
    Navigable: _sfc_main$k
  },
  props: binProps,
  setup(props) {
    const binary = binaryFn$5();
    const dirpath = binary.args[0];
    const all = binary.kwargs[0];
    binComposition();
    binary.processArgs(props.argv);
    const allValue = all.value;
    const dirpathValue = dirpath.value;
    const node = dirpath.value;
    const isNodeOk = dirpath.isNodeFound && dirpath.isNodeValidType;
    return {
      specialNames,
      dirpath: dirpathValue,
      all: allValue,
      node,
      isNodeOk
    };
  }
});
var List_vue_vue_type_style_index_0_scoped_true_lang = "\n.list ul[data-v-ede87344] {\n    column-count: 2;\n}\n";
const _withId$8 = /* @__PURE__ */ withScopeId("data-v-ede87344");
pushScopeId("data-v-ede87344");
const _hoisted_1$c = { class: "list" };
const _hoisted_2$6 = { key: 0 };
const _hoisted_3$4 = { class: "error" };
const _hoisted_4$4 = /* @__PURE__ */ createTextVNode(" is not a valid directory. ");
popScopeId();
const _sfc_render$d = /* @__PURE__ */ _withId$8((_ctx, _cache, $props, $setup, $data, $options) => {
  const _component_Navigable = resolveComponent("Navigable");
  return openBlock(), createBlock("div", _hoisted_1$c, [
    _ctx.node && _ctx.isNodeOk ? (openBlock(), createBlock("ul", _hoisted_2$6, [
      _ctx.all ? (openBlock(), createBlock(Fragment, { key: 0 }, [
        createVNode("li", null, [
          createVNode(_component_Navigable, { node: _ctx.node }, {
            default: _withId$8(() => [
              createTextVNode(toDisplayString(_ctx.specialNames.CURRENT_DIR[0]), 1)
            ]),
            _: 1
          }, 8, ["node"])
        ]),
        createVNode("li", null, [
          createVNode(_component_Navigable, {
            node: _ctx.node.parent
          }, {
            default: _withId$8(() => [
              createTextVNode(toDisplayString(_ctx.specialNames.PARENT_DIR[0]), 1)
            ]),
            _: 1
          }, 8, ["node"])
        ])
      ], 64)) : createCommentVNode("", true),
      (openBlock(true), createBlock(Fragment, null, renderList(_ctx.node.children, (child, index) => {
        return openBlock(), createBlock("li", { key: index }, [
          createVNode(_component_Navigable, { node: child }, null, 8, ["node"])
        ]);
      }), 128))
    ])) : (openBlock(), createBlock(Fragment, { key: 1 }, [
      createVNode("strong", _hoisted_3$4, toDisplayString(_ctx.dirpath), 1),
      _hoisted_4$4
    ], 64))
  ]);
});
_sfc_main$d.render = _sfc_render$d;
_sfc_main$d.__scopeId = "data-v-ede87344";
const binnameFn$1 = () => new Arg(ArgType.POSITIONAL, "binname", "the name of the binary to get help about", String);
const binaryFn$4 = () => {
  const binname = binnameFn$1();
  return new Binary("Manual", "man", "Display information about the given command.", [binname], []);
};
var _sfc_main$c = defineComponent({
  name: "Manual",
  props: binProps,
  components: {
    Executable: _sfc_main$g
  },
  setup(props) {
    var _a, _b;
    const binary = binaryFn$4();
    const binname = binary.args[0];
    binComposition();
    binary.processArgs(props.argv);
    const seeelaye = useSeeelaye();
    const binnameValue = binname.value;
    const bin = seeelaye.allBins[binnameValue];
    const hasKwargs = ((_a = bin == null ? void 0 : bin.kwargs) == null ? void 0 : _a.length) > 0;
    const hasArgs = ((_b = bin == null ? void 0 : bin.args) == null ? void 0 : _b.length) > 0;
    const hasParams = hasKwargs || hasArgs;
    const argTypes = ["kwargs", "args"];
    return {
      binname: binnameValue,
      bin,
      argTypes,
      hasParams
    };
  }
});
var Manual_vue_vue_type_style_index_0_scoped_true_lang = "\n.indent[data-v-21827bcc] {\n    margin-left: 2ch;\n}\n.blank-line[data-v-21827bcc] {\n    margin-bottom: 2ex;\n}\n.bin[data-v-21827bcc] {\n    color: var(--binary-color, var(--color-normal-green));\n}\n.arg[data-v-21827bcc] {\n    color: var(--argument-color, var(--color-normal-blue));\n    text-align: right;\n}\ntable td[data-v-21827bcc] {\n    padding: 0 1ch 0 0;\n    vertical-align: top;\n}\n";
const _withId$7 = /* @__PURE__ */ withScopeId("data-v-21827bcc");
pushScopeId("data-v-21827bcc");
const _hoisted_1$b = { class: "manual" };
const _hoisted_2$5 = /* @__PURE__ */ createVNode("strong", null, "NAME:", -1);
const _hoisted_3$3 = /* @__PURE__ */ createVNode("br", null, null, -1);
const _hoisted_4$3 = { class: "indent blank-line" };
const _hoisted_5$2 = { class: "bin" };
const _hoisted_6 = /* @__PURE__ */ createVNode("strong", null, "SYNOPSIS:", -1);
const _hoisted_7 = /* @__PURE__ */ createVNode("br", null, null, -1);
const _hoisted_8 = { class: "indent blank-line" };
const _hoisted_9 = /* @__PURE__ */ createVNode("strong", null, "DESCRIPTION:", -1);
const _hoisted_10 = /* @__PURE__ */ createVNode("br", null, null, -1);
const _hoisted_11 = /* @__PURE__ */ createTextVNode(" The following options are available: ");
const _hoisted_12 = { class: "indent" };
const _hoisted_13 = { class: "arg" };
const _hoisted_14 = /* @__PURE__ */ createTextVNode(" This binary takes no options. ");
const _hoisted_15 = { class: "error" };
const _hoisted_16 = /* @__PURE__ */ createTextVNode(" is not a valid binary. ");
popScopeId();
const _sfc_render$c = /* @__PURE__ */ _withId$7((_ctx, _cache, $props, $setup, $data, $options) => {
  const _component_Executable = resolveComponent("Executable");
  return openBlock(), createBlock("div", _hoisted_1$b, [
    _ctx.bin ? (openBlock(), createBlock(Fragment, { key: 0 }, [
      _hoisted_2$5,
      _hoisted_3$3,
      createVNode("div", _hoisted_4$3, [
        createVNode("span", _hoisted_5$2, toDisplayString(_ctx.bin.command), 1),
        createTextVNode(" -- " + toDisplayString(_ctx.bin.description), 1)
      ]),
      _hoisted_6,
      _hoisted_7,
      createVNode("div", _hoisted_8, [
        createVNode(_component_Executable, {
          bin: _ctx.bin,
          "show-args": ""
        }, null, 8, ["bin"])
      ]),
      _hoisted_9,
      _hoisted_10,
      _ctx.hasParams ? (openBlock(), createBlock(Fragment, { key: 0 }, [
        _hoisted_11,
        createVNode("table", _hoisted_12, [
          (openBlock(true), createBlock(Fragment, null, renderList(_ctx.argTypes, (key, typeIndex) => {
            return openBlock(), createBlock(Fragment, null, [
              (openBlock(true), createBlock(Fragment, null, renderList(_ctx.bin[key], (arg2, argIndex) => {
                return openBlock(), createBlock("tr", {
                  key: `${typeIndex}-${argIndex}`
                }, [
                  createVNode("td", _hoisted_13, toDisplayString(arg2.repr), 1),
                  createVNode("td", null, "-- " + toDisplayString(arg2.description), 1)
                ]);
              }), 128))
            ], 64);
          }), 256))
        ])
      ], 64)) : (openBlock(), createBlock(Fragment, { key: 1 }, [
        _hoisted_14
      ], 64))
    ], 64)) : (openBlock(), createBlock(Fragment, { key: 1 }, [
      createVNode("strong", _hoisted_15, toDisplayString(_ctx.binname), 1),
      _hoisted_16
    ], 64))
  ]);
});
_sfc_main$c.render = _sfc_render$c;
_sfc_main$c.__scopeId = "data-v-21827bcc";
const dirpathFn = () => new NodeArg(ArgType.POSITIONAL, "dirpath", "the path or name of the directory whose contents to list", FsNodeType.FOLDER, specialNames.CURRENT_DIR[0]);
const verboseFn = () => new Arg(ArgType.KEYWORD, "verbose", "whether to display more information on-screen", Boolean, false, ["v"]);
const binaryFn$3 = () => {
  const dirpath = dirpathFn();
  const verbose = verboseFn();
  return new Binary("Tree", "tree", "List contents of directory recursively like a tree.", [dirpath], [verbose]);
};
var _sfc_main$b = defineComponent({
  name: "Tree",
  components: {
    Navigable: _sfc_main$k
  },
  props: __spreadProps(__spreadValues({}, binProps), {
    allowFiles: {
      type: Boolean,
      default: false
    },
    isSubtree: {
      type: Boolean,
      default: false
    }
  }),
  setup(props, { slots }) {
    const isRoot = computed(() => !slots.default);
    const binary = binaryFn$3();
    const dirpath = binary.args[0];
    const verbose = binary.kwargs[0];
    binComposition(isRoot.value);
    binary.processArgs(props.argv);
    const verboseValue = verbose.value;
    const dirpathValue = dirpath.handlerValue;
    const node = dirpath.value;
    const isNodeValidType = props.allowFiles || (node == null ? void 0 : node.isFolder);
    const isNodeOk = dirpath.isNodeFound && isNodeValidType;
    const shapes = {
      pipe: "\u2502",
      tee: "\u251C",
      bend: "\u2514",
      dash: "\u2500",
      space: "\xA0"
    };
    const isLastChild = computed(() => {
      if (!node)
        return false;
      const siblings = node.parent.children;
      return siblings.indexOf(node) === siblings.length - 1;
    });
    const shape = computed(() => {
      if (isRoot.value) {
        return "";
      }
      if (isLastChild.value) {
        return `${shapes.bend}${shapes.dash.repeat(2)}${shapes.space}`;
      }
      return `${shapes.tee}${shapes.dash.repeat(2)}${shapes.space}`;
    });
    const childShape = computed(() => {
      if (isRoot.value) {
        return "";
      }
      if (isLastChild.value) {
        return `${shapes.space.repeat(3)}${shapes.space}`;
      }
      return `${shapes.pipe}${shapes.space.repeat(2)}${shapes.space}`;
    });
    return {
      dirpath: dirpathValue,
      verbose: verboseValue,
      node,
      isNodeOk,
      shape,
      childShape
    };
  }
});
var Tree_vue_vue_type_style_index_0_scoped_true_lang = "\n.shape[data-v-616a3e62] {\n    --default-tree-shapes-color: var(--color-secondary-fg);\n    color: var(--tree-shapes-color, var(--default-tree-shapes-color));\n}\n";
const _withId$6 = /* @__PURE__ */ withScopeId("data-v-616a3e62");
pushScopeId("data-v-616a3e62");
const _hoisted_1$a = { class: "tree" };
const _hoisted_2$4 = { class: "shape" };
const _hoisted_3$2 = { class: "shape" };
const _hoisted_4$2 = { class: "error" };
const _hoisted_5$1 = /* @__PURE__ */ createTextVNode(" is not a valid directory. ");
popScopeId();
const _sfc_render$b = /* @__PURE__ */ _withId$6((_ctx, _cache, $props, $setup, $data, $options) => {
  var _a;
  const _component_Navigable = resolveComponent("Navigable");
  const _component_Tree = resolveComponent("Tree", true);
  return openBlock(), createBlock("div", _hoisted_1$a, [
    _ctx.node && _ctx.isNodeOk ? (openBlock(), createBlock(Fragment, { key: 0 }, [
      renderSlot(_ctx.$slots, "default", {}, void 0, true),
      createVNode("span", _hoisted_2$4, toDisplayString(_ctx.shape), 1),
      createVNode(_component_Navigable, {
        node: _ctx.node,
        "show-aliases": _ctx.verbose
      }, null, 8, ["node", "show-aliases"]),
      (openBlock(true), createBlock(Fragment, null, renderList((_a = _ctx.node.children) != null ? _a : [], (child, index) => {
        return openBlock(), createBlock(_component_Tree, {
          key: index,
          argv: [
            ..._ctx.verbose ? ["--verbose"] : [],
            child.absolutePath
          ],
          "allow-files": "",
          "is-subtree": ""
        }, {
          default: _withId$6(() => [
            renderSlot(_ctx.$slots, "default", {}, void 0, true),
            createVNode("span", _hoisted_3$2, toDisplayString(_ctx.childShape), 1)
          ]),
          _: 2
        }, 1032, ["argv"]);
      }), 128))
    ], 64)) : (openBlock(), createBlock(Fragment, { key: 1 }, [
      createVNode("strong", _hoisted_4$2, toDisplayString(_ctx.dirpath), 1),
      _hoisted_5$1
    ], 64))
  ]);
});
_sfc_main$b.render = _sfc_render$b;
_sfc_main$b.__scopeId = "data-v-616a3e62";
const grootFn = () => new Arg(ArgType.KEYWORD, "groot", "whether to run command as Groot", Boolean, false, ["g"]);
const binaryFn$2 = () => {
  const groot = grootFn();
  return new Binary("WhoAmI", "whoami", "Display the name of the current active user.", [], [groot]);
};
var _sfc_main$a = defineComponent({
  name: "WhoAmI",
  props: binProps,
  setup(props) {
    const binary = binaryFn$2();
    const groot = binary.kwargs[0];
    binComposition();
    binary.processArgs(props.argv);
    const grootValue = groot.value;
    const seeelaye = useSeeelaye();
    const username = grootValue ? "groot" : seeelaye.state.username;
    return {
      username
    };
  }
});
const _hoisted_1$9 = { class: "whoami" };
function _sfc_render$a(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock("div", _hoisted_1$9, toDisplayString(_ctx.username), 1);
}
_sfc_main$a.render = _sfc_render$a;
const binaryFn$1 = () => new Binary("WorkDir", "pwd", "Display the current working directory.", [], []);
var _sfc_main$9 = defineComponent({
  name: "WorkDir",
  setup() {
    var _a, _b;
    binComposition();
    const seeelaye = useSeeelaye();
    const workDir = (_b = (_a = seeelaye.state.currentNode) == null ? void 0 : _a.absolutePath) != null ? _b : "unknown";
    return {
      workDir
    };
  }
});
const _hoisted_1$8 = { class: "pwd" };
function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock("div", _hoisted_1$8, toDisplayString(_ctx.workDir), 1);
}
_sfc_main$9.render = _sfc_render$9;
const builtInBinaries = Object.fromEntries([
  binaryFn$a,
  binaryFn$9,
  binaryFn$8,
  binaryFn$7,
  binaryFn$6,
  binaryFn$5,
  binaryFn$4,
  binaryFn$3,
  binaryFn$2,
  binaryFn$1
].map((binaryFn2) => {
  const binary = binaryFn2();
  return [
    binary.command,
    binary
  ];
}));
const binaryComponents = {
  ChangeDir: _sfc_main$j,
  Clear: _sfc_main$i,
  Hello: _sfc_main$h,
  Help: _sfc_main$f,
  Hostname: _sfc_main$e,
  List: _sfc_main$d,
  Manual: _sfc_main$c,
  Tree: _sfc_main$b,
  WhoAmI: _sfc_main$a,
  WorkDir: _sfc_main$9
};
const binnameFn = () => new Arg(ArgType.POSITIONAL, "binname", "the name of the invalid binary that was invoked", String, void 0, ["b"]);
const binaryFn = () => {
  const binname = binnameFn();
  return new Binary("Bad", "bad", "Display the invalidity of the input and suggest alternatives.", [binname], []);
};
var _sfc_main$8 = defineComponent({
  name: "Bad",
  components: {
    Executable: _sfc_main$g
  },
  props: binProps,
  setup(props) {
    const binary = binaryFn();
    const binname = binary.args[0];
    binComposition();
    binary.processArgs(props.argv);
    const binnameValue = binname.value;
    return {
      binname: binnameValue,
      helpBinary: binaryFn$7()
    };
  }
});
const _hoisted_1$7 = { class: "bad" };
const _hoisted_2$3 = /* @__PURE__ */ createTextVNode(" Command ");
const _hoisted_3$1 = { class: "error" };
const _hoisted_4$1 = /* @__PURE__ */ createTextVNode(" does not exist in the CLI. Try ");
const _hoisted_5 = /* @__PURE__ */ createTextVNode(". ");
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Executable = resolveComponent("Executable");
  return openBlock(), createBlock("div", _hoisted_1$7, [
    _hoisted_2$3,
    createVNode("strong", _hoisted_3$1, toDisplayString(_ctx.binname), 1),
    _hoisted_4$1,
    createVNode(_component_Executable, { bin: _ctx.helpBinary }, null, 8, ["bin"]),
    _hoisted_5
  ]);
}
_sfc_main$8.render = _sfc_render$8;
var _sfc_main$7 = defineComponent({
  name: "Nop",
  setup() {
    binComposition();
  }
});
const _hoisted_1$6 = { class: "nop" };
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock("div", _hoisted_1$6);
}
_sfc_main$7.render = _sfc_render$7;
class Seeelaye {
  constructor(store, storeModule, excludedBins = [], additionalBins = {}) {
    this.store = store;
    this.storeModule = storeModule;
    const allBins = __spreadValues(__spreadValues({}, Object.fromEntries(Object.keys(builtInBinaries).filter((key) => !excludedBins.includes(key)).map((key) => [key, builtInBinaries[key]]))), additionalBins);
    const sortedBins = {};
    Object.keys(allBins).sort().forEach((name) => {
      sortedBins[name] = allBins[name];
    });
    this.allBins = sortedBins;
    Interaction.allBins = sortedBins;
  }
  get state() {
    return this.store.state[this.storeModule];
  }
  compute(getterName, payload = null) {
    const fqn = `${this.storeModule}/${getterName}`;
    if (payload) {
      return this.store.getters[fqn](payload);
    }
    return this.store.getters[fqn]();
  }
  commit(mutationName, payload = null) {
    const fqn = `${this.storeModule}/${mutationName}`;
    if (payload) {
      this.store.commit(fqn, payload);
      return;
    }
    this.store.commit(fqn);
  }
  dispatch(actionName, payload = null) {
    const fqn = `${this.storeModule}/${actionName}`;
    if (payload) {
      return this.store.dispatch(fqn, payload);
    }
    return this.store.dispatch(fqn);
  }
  install(app) {
    app.provide(seeelayeKey, this);
    app.config.globalProperties.$seeelaye = this;
    app.component("Bad", _sfc_main$8);
    app.component("Nop", _sfc_main$7);
  }
}
const state = () => ({
  username: "guest",
  hostname: "seeelaye",
  tree: null,
  currentNode: null,
  history: [],
  isReady: false,
  input: ""
});
const getGetters = () => ({
  nodeLocatedAt(state2) {
    return (payload) => {
      var _a, _b;
      const { path } = payload;
      let node = state2.currentNode;
      const parts = pathSplit(path);
      for (let i = 0; i < parts.length; i += 1) {
        const part = parts[i];
        if (!node)
          return null;
        if (i === 0 && ((_a = state2.tree) == null ? void 0 : _a.hasName(part))) {
          node = state2.tree;
        } else if (specialNames.CURRENT_DIR.includes(part))
          ;
        else if (specialNames.PARENT_DIR.includes(part)) {
          node = node.parent;
        } else {
          node = (_b = node.children.find((child) => child.hasName(part))) != null ? _b : null;
        }
      }
      return node;
    };
  }
});
const mutations = {
  setUsername(state2, payload) {
    state2.username = payload.username;
  },
  setHostname(state2, payload) {
    state2.hostname = payload.hostname;
  },
  setTree(state2, payload) {
    state2.tree = payload.tree;
  },
  setCurrentNode(state2, payload) {
    state2.currentNode = payload.currentNode;
  },
  setIsReady(state2, payload) {
    state2.isReady = payload.isReady;
  },
  deleteInteractions(state2) {
    state2.history = [];
  },
  pushInteraction(state2, payload) {
    state2.history.push(payload.interaction);
  },
  hideInteractions(state2) {
    state2.history.forEach((interaction) => {
      interaction.hide();
    });
  },
  setInput(state2, payload) {
    state2.input = payload.input;
  }
};
const getActions = () => ({
  async executeCmd(context, payload) {
    const { state: state2, commit } = context;
    const { rawInput } = payload;
    if (!state2.isReady) {
      console.error(`Command '${rawInput}' rejected as terminal is busy`);
      return;
    }
    if (!state2.currentNode) {
      console.error("Cannot determine working directory");
      return;
    }
    const ctx = {
      wd: state2.currentNode
    };
    commit("setIsReady", { isReady: false });
    const interaction = new Interaction(ctx, rawInput);
    commit("pushInteraction", { interaction });
    interaction.processOutput();
  }
});
const getVuexModule = () => ({
  namespaced: true,
  state,
  getters: getGetters(),
  mutations,
  actions: getActions()
});
var _sfc_main$6 = defineComponent({
  name: "Spinner",
  setup() {
    const spinnerStrings = [
      "     ",
      "=    ",
      "==   ",
      "===  ",
      " === ",
      "  ===",
      "   ==",
      "    =",
      "     ",
      "    =",
      "   ==",
      "  ===",
      " === ",
      "===  ",
      "==   ",
      "=    "
    ];
    const index = ref(0);
    const displayText = computed(() => spinnerStrings[index.value].replace(/\s/g, "\xA0"));
    let updateLooper;
    const startLooping = () => {
      updateLooper = window.setInterval(() => {
        index.value = (index.value + 1) % spinnerStrings.length;
      }, 100);
    };
    const stopLooping = () => {
      window.clearInterval(updateLooper);
    };
    onMounted(startLooping);
    onBeforeUnmount(stopLooping);
    return {
      displayText
    };
  }
});
var Spinner_vue_vue_type_style_index_0_scoped_true_lang = "\n.spinner[data-v-f4030d38] {\n    font-variant-ligatures: none;\n}\n.spinner .edge[data-v-f4030d38] {\n    color: var(--spinner-edge-color, var(--color-secondary-fg));\n}\n.spinner .char[data-v-f4030d38] {\n    color: var(--spinner-char-color, var(--color-normal-fg));\n}\n";
const _withId$5 = /* @__PURE__ */ withScopeId("data-v-f4030d38");
pushScopeId("data-v-f4030d38");
const _hoisted_1$5 = { class: "spinner" };
const _hoisted_2$2 = /* @__PURE__ */ createVNode("span", { class: "edge" }, "[", -1);
const _hoisted_3 = { class: "char" };
const _hoisted_4 = /* @__PURE__ */ createVNode("span", { class: "edge" }, "]", -1);
popScopeId();
const _sfc_render$6 = /* @__PURE__ */ _withId$5((_ctx, _cache, $props, $setup, $data, $options) => {
  return openBlock(), createBlock("div", _hoisted_1$5, [
    _hoisted_2$2,
    createVNode("span", _hoisted_3, toDisplayString(_ctx.displayText), 1),
    _hoisted_4
  ]);
});
_sfc_main$6.render = _sfc_render$6;
_sfc_main$6.__scopeId = "data-v-f4030d38";
var _sfc_main$5 = defineComponent({
  name: "Prompt",
  props: {
    workingDirectory: {
      type: Object
    }
  },
  setup(props) {
    const seeelaye = useSeeelaye();
    const username = computed(() => seeelaye.state.username);
    const hostname = computed(() => seeelaye.state.hostname);
    const currentNodeName = computed(() => {
      var _a;
      return (_a = seeelaye.state.currentNode) == null ? void 0 : _a.name;
    });
    const workingDirectoryName = computed(() => {
      var _a, _b, _c;
      return (_c = (_b = (_a = props.workingDirectory) == null ? void 0 : _a.name) != null ? _b : currentNodeName.value) != null ? _c : "unknown";
    });
    return {
      username,
      hostname,
      workingDirectoryName
    };
  }
});
var Prompt_vue_vue_type_style_index_0_scoped_true_lang = "\n.prompt[data-v-039c5e2e] {\n    border-bottom: 1px solid transparent; /* to vertically align with input field */\n}\n";
const _withId$4 = /* @__PURE__ */ withScopeId("data-v-039c5e2e");
pushScopeId("data-v-039c5e2e");
const _hoisted_1$4 = { class: "prompt" };
popScopeId();
const _sfc_render$5 = /* @__PURE__ */ _withId$4((_ctx, _cache, $props, $setup, $data, $options) => {
  return openBlock(), createBlock("span", _hoisted_1$4, " [" + toDisplayString(_ctx.username) + "@" + toDisplayString(_ctx.hostname) + " " + toDisplayString(_ctx.workingDirectoryName) + "]$ ", 1);
});
_sfc_main$5.render = _sfc_render$5;
_sfc_main$5.__scopeId = "data-v-039c5e2e";
var _sfc_main$4 = defineComponent({
  name: "ErrorBoundary",
  setup() {
    const errorMessage = ref(null);
    onErrorCaptured((err) => {
      errorMessage.value = err.message;
      return false;
    });
    return {
      errorMessage
    };
  }
});
const _hoisted_1$3 = { class: "error-boundary" };
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock("div", _hoisted_1$3, [
    _ctx.errorMessage ? (openBlock(), createBlock("span", {
      key: 0,
      class: "error",
      innerHTML: _ctx.errorMessage
    }, null, 8, ["innerHTML"])) : renderSlot(_ctx.$slots, "default", { key: 1 })
  ]);
}
_sfc_main$4.render = _sfc_render$4;
var _sfc_main$3 = defineComponent({
  name: "Past",
  components: __spreadValues({
    ErrorBoundary: _sfc_main$4,
    Prompt: _sfc_main$5
  }, binaryComponents),
  setup() {
    const seeelaye = useSeeelaye();
    const visibleHistory = computed(() => seeelaye.state.history.filter((interaction) => interaction.isVisible));
    return {
      visibleHistory
    };
  }
});
var Past_vue_vue_type_style_index_0_scoped_true_lang = "\n.interaction[data-v-340ea723] {\n    margin-bottom: 2ex;\n}\n";
const _withId$3 = /* @__PURE__ */ withScopeId("data-v-340ea723");
pushScopeId("data-v-340ea723");
const _hoisted_1$2 = { class: "past" };
const _hoisted_2$1 = /* @__PURE__ */ createVNode("br", null, null, -1);
popScopeId();
const _sfc_render$3 = /* @__PURE__ */ _withId$3((_ctx, _cache, $props, $setup, $data, $options) => {
  const _component_Prompt = resolveComponent("Prompt");
  const _component_ErrorBoundary = resolveComponent("ErrorBoundary");
  return openBlock(), createBlock("div", _hoisted_1$2, [
    (openBlock(true), createBlock(Fragment, null, renderList(_ctx.visibleHistory, (interaction, index) => {
      return openBlock(), createBlock("div", {
        key: index,
        class: "interaction"
      }, [
        createVNode(_component_Prompt, {
          "working-directory": interaction.context.wd
        }, null, 8, ["working-directory"]),
        createTextVNode(" " + toDisplayString(interaction.rawInput) + " ", 1),
        _hoisted_2$1,
        createVNode(_component_ErrorBoundary, null, {
          default: _withId$3(() => [
            (openBlock(), createBlock(resolveDynamicComponent(interaction.output.component), {
              argv: interaction.output.argv
            }, null, 8, ["argv"]))
          ]),
          _: 2
        }, 1024)
      ]);
    }), 128))
  ]);
});
_sfc_main$3.render = _sfc_render$3;
_sfc_main$3.__scopeId = "data-v-340ea723";
const autocompleteComposition = () => {
  const seeelaye = useSeeelaye();
  const completeBin = (partialBinCmd) => {
    const allBinCmds = Object.keys(seeelaye.allBins);
    return allBinCmds.filter((name) => name.startsWith(partialBinCmd)).map((name) => ({
      entity: seeelaye.allBins[name],
      text: `${name} `
    }));
  };
  const completePath = (partialPath) => {
    var _a;
    let node;
    if (seeelaye.state.currentNode) {
      node = seeelaye.state.currentNode;
    } else {
      throw new Error("Cannot determine working directory.");
    }
    const suggestion = [];
    const pathParts = pathSplit(partialPath);
    let i = 0;
    let isCompleted = true;
    for (; i < pathParts.length; i += 1) {
      const pathPart = pathParts[i];
      let suggestionPart = null;
      if (i === 0 && ((_a = seeelaye.state.tree) == null ? void 0 : _a.hasName(pathPart))) {
        suggestionPart = pathPart;
        node = seeelaye.state.tree;
      } else if (specialNames.CURRENT_DIR.includes(pathPart)) {
        [, suggestionPart] = specialNames.CURRENT_DIR;
      } else if (specialNames.PARENT_DIR.includes(pathPart)) {
        [, suggestionPart] = specialNames.PARENT_DIR;
        node = node.parent;
      } else {
        const noSlash = pathPart.replace("/", "");
        const children = node.children.filter((child) => child.hasName(noSlash, true));
        if (children.length === 0) {
          isCompleted = false;
          break;
        } else if (children.length === 1) {
          [node] = children;
        } else {
          return children.map((child) => ({
            entity: child,
            text: [...suggestion, suggestionPart != null ? suggestionPart : child.autocompleteName].join("")
          }));
        }
      }
      suggestion.push(suggestionPart != null ? suggestionPart : node.autocompleteName);
    }
    if (!isCompleted) {
      suggestion.push(...pathParts.slice(i));
    }
    if (partialPath === suggestion.join("") && (node == null ? void 0 : node.isFolder)) {
      return node.children.map((item) => ({
        entity: item,
        text: [...suggestion, item.autocompleteName].join("")
      }));
    }
    return [{
      entity: node,
      text: suggestion.join("")
    }];
  };
  const command = computed(() => seeelaye.state.input);
  const suggestions = ref([]);
  const populateInput = (suggestion) => {
    const parts = command.value.split(/\s+/);
    seeelaye.commit("setInput", {
      input: [...parts.slice(0, -1), suggestion].join(" ")
    });
    suggestions.value = [];
  };
  const autocomplete = () => {
    const [bin, ...argv] = command.value.split(/\s+/);
    if (argv.length) {
      const [lastArg] = argv.slice(-1);
      suggestions.value = completePath(lastArg);
    } else {
      suggestions.value = completeBin(bin);
    }
    if (suggestions.value.length === 1) {
      populateInput(suggestions.value[0].text);
    }
  };
  return {
    suggestions,
    autocomplete,
    populateInput
  };
};
var _sfc_main$2 = defineComponent({
  name: "Input",
  setup(props, { emit }) {
    const seeelaye = useSeeelaye();
    const command = computed({
      get: () => seeelaye.state.input,
      set: (val) => {
        seeelaye.commit("setInput", { input: val });
      }
    });
    const submit = () => {
      seeelaye.dispatch("executeCmd", {
        rawInput: command.value
      });
      command.value = "";
    };
    const nonEmptyHistory = computed(() => seeelaye.state.history.filter((interaction) => Boolean(interaction.rawInput)));
    const traversalIndex = ref(0);
    const commandBackup = ref("");
    const traversePrev = () => {
      if (traversalIndex.value === nonEmptyHistory.value.length) {
        emit("error");
        return;
      }
      if (traversalIndex.value === 0) {
        commandBackup.value = command.value;
      }
      traversalIndex.value += 1;
      const index = nonEmptyHistory.value.length - traversalIndex.value;
      command.value = nonEmptyHistory.value[index].rawInput;
    };
    const traverseNext = () => {
      if (traversalIndex.value === 0) {
        emit("error");
        return;
      }
      traversalIndex.value -= 1;
      if (traversalIndex.value === 0) {
        command.value = commandBackup.value;
      } else {
        const index = nonEmptyHistory.value.length - traversalIndex.value;
        command.value = nonEmptyHistory.value[index].rawInput;
      }
    };
    const fireComplete = () => {
      emit("complete");
    };
    return {
      command,
      handleEnter: submit,
      handleArrowUp: traversePrev,
      handleArrowDown: traverseNext,
      handleTab: fireComplete
    };
  }
});
var Input_vue_vue_type_style_index_0_scoped_true_lang = "\n.input[data-v-8228144a] {\n    appearance: none;\n\n    color: inherit;\n    font: inherit;\n    caret-color: currentColor;\n\n    background: none;\n\n    min-width: 32ch;\n    padding: 0;\n    border: none;\n    border-bottom: 1px solid transparent;\n}\n.input[data-v-8228144a]:focus {\n    outline: none;\n    border-bottom-color: var(--color-highlight-bg);\n}\n[data-v-8228144a]::placeholder {\n    color: inherit;\n\n    opacity: 0.5;\n}\n";
const _withId$2 = /* @__PURE__ */ withScopeId("data-v-8228144a");
const _sfc_render$2 = /* @__PURE__ */ _withId$2((_ctx, _cache, $props, $setup, $data, $options) => {
  return withDirectives((openBlock(), createBlock("input", {
    class: "input",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.command = $event),
    type: "text",
    autocomplete: "off",
    autocapitalize: "off",
    spellcheck: "false",
    onKeydown: [
      _cache[2] || (_cache[2] = withKeys(withModifiers((...args) => _ctx.handleEnter && _ctx.handleEnter(...args), ["exact"]), ["enter"])),
      _cache[3] || (_cache[3] = withKeys(withModifiers((...args) => _ctx.handleArrowUp && _ctx.handleArrowUp(...args), ["exact", "prevent"]), ["arrow-up"])),
      _cache[4] || (_cache[4] = withKeys(withModifiers((...args) => _ctx.handleArrowDown && _ctx.handleArrowDown(...args), ["exact", "prevent"]), ["arrow-down"])),
      _cache[5] || (_cache[5] = withKeys(withModifiers((...args) => _ctx.handleTab && _ctx.handleTab(...args), ["exact", "prevent"]), ["tab"]))
    ]
  }, null, 544)), [
    [vModelText, _ctx.command]
  ]);
});
_sfc_main$2.render = _sfc_render$2;
_sfc_main$2.__scopeId = "data-v-8228144a";
var _sfc_main$1 = defineComponent({
  name: "Present",
  components: {
    Prompt: _sfc_main$5,
    Input: _sfc_main$2,
    Executable: _sfc_main$g,
    Navigable: _sfc_main$k
  },
  setup() {
    const { suggestions, autocomplete, populateInput } = autocompleteComposition();
    const seeelaye = useSeeelaye();
    watch(() => seeelaye.state.input, (newVal, oldVal) => {
      if (newVal !== oldVal) {
        suggestions.value = [];
      }
    });
    const isReady = computed(() => seeelaye.state.isReady);
    return {
      FsNode,
      Binary,
      isReady,
      suggestions,
      populateInput,
      handleAutocomplete: autocomplete
    };
  }
});
var Present_vue_vue_type_style_index_0_scoped_true_lang = "\n.is-hidden[data-v-4f2600f4] {\n    visibility: hidden;\n}\n.input-area[data-v-4f2600f4] {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n\n    gap: 1ch;\n}\n.input-area .input[data-v-4f2600f4] {\n    flex-grow: 1;\n}\n.present[data-v-4f2600f4]:focus-within {\n    color: var(--color-highlight-fg);\n}\n";
const _withId$1 = /* @__PURE__ */ withScopeId("data-v-4f2600f4");
pushScopeId("data-v-4f2600f4");
const _hoisted_1$1 = { class: "input-area" };
popScopeId();
const _sfc_render$1 = /* @__PURE__ */ _withId$1((_ctx, _cache, $props, $setup, $data, $options) => {
  const _component_Prompt = resolveComponent("Prompt");
  const _component_Input = resolveComponent("Input");
  const _component_Navigable = resolveComponent("Navigable");
  const _component_Executable = resolveComponent("Executable");
  return openBlock(), createBlock("div", {
    class: ["present", [{ "is-hidden": !_ctx.isReady }]]
  }, [
    createVNode("label", _hoisted_1$1, [
      createVNode(_component_Prompt),
      createVNode(_component_Input, {
        placeholder: "command",
        onComplete: _ctx.handleAutocomplete
      }, null, 8, ["onComplete"])
    ]),
    createVNode("ul", null, [
      (openBlock(true), createBlock(Fragment, null, renderList(_ctx.suggestions, (suggestion, index) => {
        return openBlock(), createBlock("li", {
          key: index,
          onClick: ($event) => _ctx.populateInput(suggestion.text)
        }, [
          suggestion.entity instanceof _ctx.FsNode ? (openBlock(), createBlock(_component_Navigable, {
            key: 0,
            node: suggestion.entity,
            "is-clickable": false,
            "show-aliases": ""
          }, null, 8, ["node"])) : createCommentVNode("", true),
          suggestion.entity instanceof _ctx.Binary ? (openBlock(), createBlock(_component_Executable, {
            key: 1,
            bin: suggestion.entity,
            "is-clickable": false,
            "show-args": ""
          }, null, 8, ["bin"])) : createCommentVNode("", true)
        ], 8, ["onClick"]);
      }), 128))
    ])
  ], 2);
});
_sfc_main$1.render = _sfc_render$1;
_sfc_main$1.__scopeId = "data-v-4f2600f4";
var _sfc_main = defineComponent({
  name: "Terminal",
  components: {
    Present: _sfc_main$1,
    Past: _sfc_main$3
  },
  setup() {
    const present = ref(null);
    const seeelaye = useSeeelaye();
    let unsubscribe;
    onMounted(() => {
      unsubscribe = seeelaye.store.subscribe((mutation) => {
        var _a;
        if (mutation.type.includes("/setIsReady") && mutation.payload.isReady) {
          (_a = present.value) == null ? void 0 : _a.$el.scrollIntoView();
        }
      });
    });
    onBeforeUnmount(() => {
      if (unsubscribe) {
        unsubscribe();
      }
    });
    return {
      present
    };
  }
});
var Terminal_vue_vue_type_style_index_0_scoped_true_lang = '\n.terminal[data-v-0af8c77f] {\n    --default-font-family: "JetBrains Mono", monospace;\n    --default-font-size: 14px;\n    --default-line-height: 1.4;\n\n    --default-height: 100%;\n\n    --default-padding: 2ex 1ch;\n\n    background: var(--color-normal-bg);\n    color: var(--color-normal-fg);\n\n    font-family: var(--font-family, var(--default-font-family));\n    font-size: var(--font-size, var(--default-font-size));\n    line-height: var(--line-height, var(--default-line-height));\n\n    height: var(--height, var(--default-height));\n\n    padding: var(--padding, var(--default-padding));\n}\n[data-v-0af8c77f] .terminal-content {\n    --default-content-max-width: 80ch;\n\n    --default-content-border-width: 1px;\n\n    max-width: var(--content-max-width, var(--default-content-max-width));\n\n    border-right: var(--content-border-width, var(--default-content-border-width))\n      solid\n      var(--color-highlight-bg);\n}\n[data-v-0af8c77f] .terminal-content p {\n    margin: 0;\n}\n[data-v-0af8c77f] .terminal-content ul {\n    list-style: none;\n\n    padding-left: 0;\n    margin: 0;\n}\n[data-v-0af8c77f] .terminal-content a {\n    color: inherit;\n}\n[data-v-0af8c77f] .terminal-content .error {\n    color: var(--color-normal-red);\n}\n';
const _withId = /* @__PURE__ */ withScopeId("data-v-0af8c77f");
pushScopeId("data-v-0af8c77f");
const _hoisted_1 = { class: "terminal" };
const _hoisted_2 = { class: "terminal-content" };
popScopeId();
const _sfc_render = /* @__PURE__ */ _withId((_ctx, _cache, $props, $setup, $data, $options) => {
  const _component_Past = resolveComponent("Past");
  const _component_Present = resolveComponent("Present");
  return openBlock(), createBlock("div", _hoisted_1, [
    createVNode("div", _hoisted_2, [
      renderSlot(_ctx.$slots, "default", {}, () => [
        createVNode(_component_Past),
        createVNode(_component_Present, { ref: "present" }, null, 512)
      ], {}, true)
    ])
  ]);
});
_sfc_main.render = _sfc_render;
_sfc_main.__scopeId = "data-v-0af8c77f";
export { Arg, ArgType, Binary, _sfc_main$g as Executable, FsNode, FsNodeType, Interaction, _sfc_main$k as Navigable, NodeArg, Seeelaye, _sfc_main$6 as Spinner, _sfc_main as Terminal, binComposition, binProps, getVuexModule, nameExtSplit, seeelayeKey, useSeeelaye };
